<template>
  <intersect @enter="triggered = true">
    <span class="iCountUp">
      <i-count-up v-if="triggered"
                  :start-val="0"
                  :end-val="endVal"
                  :decimals="0"
                  :duration="duration"
                  :options="options"></i-count-up>
    </span>
  </intersect>
</template>

<script>
import ICountUp from "vue-countup-v2";
import Intersect from "vue-intersect";

export default {
  name: "CountUp",
  components: {
    ICountUp,
    Intersect
  },
  props: {
    startVal: {
      type: Number,
      default: 0
    },
    endVal: {
      type: Number,
      required: true
    },
    duration: {
      type: Number,
      default: 3
    },
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ",",
        decimal: ".",
        prefix: "",
        suffix: ""
      },
      triggered: false
    };
  },
  created () {
    this.options.prefix = this.prefix;
    this.options.suffix = this.suffix;
  }
};
</script>
